module.exports = __webpack_public_path__ + "img/01.8c9fd93d.jpg";